<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="350">
      <v-card>
        <v-card-title
          class="headline body-1 blue-grey darken-1 lighten-1 white--text font-weight-thin"
          primary-title
        >
          <v-icon class="white--text mr-2">mdi-shield-lock</v-icon>Digite o PIN
        </v-card-title>
        <v-card-text class="pa-8">
          <v-form
            novalidate
            ref="form"
            v-model="valid"
            lazy-validation
            autocomplete="off"
          >
            <v-text-field
              v-model="actualPassword"
              :rules="pwdRules"
              label="Digite o PIN"
              required
              filled
              :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="() => (value = !value)"
              :type="value ? 'password' : 'text'"
            ></v-text-field>
            <v-card-actions>
              <v-btn
                color="blue-grey lighten-2"
                text
                block
                @click="toPay"
                :disabled="!valid"
              >
                Confirmar
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import eventBus from "../../main";
import jwtDecode from "jwt-decode";
import convertToB64 from "../../../services/convertToB64";
export default {
  name: "OpenPin",
  data: () => ({
    actualPassword: "",
    dialog: false,
    valid: true,
    value: true,
    pwdRules: [v => !!v || "PIN é requerido", v => (v && v.length >= 6) || ""]
  }),
  methods: {
    toPay() {
      if (!this.$store.getters.getBalanceClient && this.$store.getters.getButtonWallet) {
        let payload = {
          color: "error",
          right: "center",
          top: "top",
          text: "Ups! Não tem saldo suficiente",
          errorLogin: true
        };
        eventBus.$emit("openInfo", payload); // emit the event to the bus
        return false;
      }

      if (this.$refs.form.validate()) {
        let encryptedPass = convertToB64.toRsa(this.actualPassword);
        const userToken = localStorage.getItem("token");
        const decode = jwtDecode(userToken);
        let ca = decode.CA;
        let payload = {
          pin: encryptedPass,
          amount: this.$store.getters.getPrice,
          productName: this.$store.getters.getProduct,
          entityName: this.$store.getters.getEntity,
          refOrigin: this.$store.getters.getRefOrigin,
          refFrom: ca,
          reference: this.$store.getters.getReference,
          payType: this.$store.getters.getPayType,
          model: this.$store.getters.getCellphoneH1,
          productUUID: this.$store.getters.getProductUUID,
          productCategoryName: this.$store.getters.getProductCategoryName,
          productCategoryUUID: this.$store.getters.getProductCategoryUUID,
          rechargeCellphone: this.$store.getters.getRechargeCellphone,
          description: this.$store.getters.getDescriptionUnitel
        };
        this.$store.dispatch("checkConnectionPay", payload);
      }
    }
  },
  created() {
    const self = this;
    eventBus.$on("openPin", function(value) {
      self.dialog = value;
      self.actualPassword = "";
    });
  }
};
</script>

<style scoped></style>
